export default __webpack_public_path__ + "static/media/soleil_book.e5ff07c2.woff2";